/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TOTPRegisterChallengeOptions
 */
export interface TOTPRegisterChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterChallengeOptions
     */
    key_uri: string;
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterChallengeOptions
     */
    qr_code_data_b64: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TOTPRegisterChallengeOptions
     */
    recovery_codes: Array<string>;
}

/**
 * Check if a given object implements the TOTPRegisterChallengeOptions interface.
 */
export function instanceOfTOTPRegisterChallengeOptions(value: object): value is TOTPRegisterChallengeOptions {
    if (!('key_uri' in value) || value['key_uri'] === undefined) return false;
    if (!('qr_code_data_b64' in value) || value['qr_code_data_b64'] === undefined) return false;
    if (!('recovery_codes' in value) || value['recovery_codes'] === undefined) return false;
    return true;
}

export function TOTPRegisterChallengeOptionsFromJSON(json: any): TOTPRegisterChallengeOptions {
    return TOTPRegisterChallengeOptionsFromJSONTyped(json, false);
}

export function TOTPRegisterChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'key_uri': json['key_uri'],
        'qr_code_data_b64': json['qr_code_data_b64'],
        'recovery_codes': json['recovery_codes'],
    };
}

export function TOTPRegisterChallengeOptionsToJSON(json: any): TOTPRegisterChallengeOptions {
    return TOTPRegisterChallengeOptionsToJSONTyped(json, false);
}

export function TOTPRegisterChallengeOptionsToJSONTyped(value?: TOTPRegisterChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key_uri': value['key_uri'],
        'qr_code_data_b64': value['qr_code_data_b64'],
        'recovery_codes': value['recovery_codes'],
    };
}

